import { createContext, useMemo } from 'react';

export type DeviceType = 'MOBILE' | 'DESKTOP';

export type KeyboardType = 'IOS' | 'ANDROID' | 'WINDOWS' | 'DEFAULT';

export type KeyboardInputType = 'number' | 'tel' | 'text' | undefined;
type KeyboardInputMode = 'tel' | 'text' | 'numeric' | 'decimal' | undefined;
export interface KeyboardConfig {
  type: KeyboardInputType;
  inputMode?: KeyboardInputMode;
  step?: number;
}

export type DeviceContextType = {
  device: DeviceType | null;
  setDevice: (device: DeviceType) => void;
  keyboardMode: KeyboardType;
  setKeyboardModeManually: (mode: KeyboardType) => void;
  keyboardConfig: KeyboardConfig;
};

export const DeviceContext = createContext<DeviceContextType | null>(null);
